import { queryOptions } from '@tanstack/react-query';

import { shortCacheOptions } from '@platform/core/state';

import { getElocApiClient } from '../../eloc-api-client';

export const getCylanceConsoleQueryKey = () => ['eloc', 'get-cylance-console'];

export const cylanceConsoleQuery = () =>
  queryOptions({
    queryFn: async () => {
      const client = await getElocApiClient();
      return client.getCylanceConsole();
    },
    queryKey: getCylanceConsoleQueryKey(),
    ...shortCacheOptions,
  });
